module.exports = __webpack_public_path__ + "static/bg (9)-6150215f364d453ade95fecbcfb110fd.jpg";